"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Curtain = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_Curtain_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 1h3V0H0v1h1v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V1ZM2 9v6h10V9H2Zm10-1V7H2v1h10Zm0-3v1H2V5h10Zm0-1V3H2v1h10Zm0-3v1H2V1h10Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 2.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0ZM14.5 5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1ZM15 6.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0ZM14.5 9a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1ZM15 10.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0ZM14.5 13a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1ZM15 14.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_Curtain_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = Curtain;
exports["default"] = _default;